import { ViewportState } from '@/interfaces/ViewportState'

export const state: ViewportState = {
	width: window.innerWidth
}
